/* WOEST CUSTOM – Ventum configurator (sections/woest-ventum-configurator.liquid). Zie claude/woest-custom-thema.md, functie W.
   De server zet alle keuzes al in de HTML. Dit script wisselt alleen wat zichtbaar is, wisselt de foto's,
   rekent het totaal uit en zet fiets + upgrades in één keer in de winkelwagen. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '€{{amount_with_comma_separator}}';
    function delimit(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var dec = parts[1] ? decimal + parts[1] : '';
      return whole + dec;
    }
    var match = fmt.match(placeholder);
    var kind = match ? match[1] : 'amount';
    var whole = cents % 100 === 0;
    switch (kind) {
      case 'amount':
        value = delimit(cents, whole ? 0 : 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = delimit(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = delimit(cents, whole ? 0 : 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = delimit(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = delimit(cents, whole ? 0 : 2, "'", '.');
        break;
      default:
        value = delimit(cents, whole ? 0 : 2, '.', ',');
    }
    return fmt.replace(placeholder, value);
  }

  function Configurator(root) {
    this.root = root;
    var dataEl = root.querySelector('[data-wvc-json]');
    try {
      this.data = JSON.parse(dataEl.textContent);
    } catch (e) {
      this.data = { products: {}, labels: {}, fit: {} };
    }
    this.labels = this.data.labels || {};
    this.imageIndex = 0;
    this.currentHandle = null;
    this.chosenSize = null;
    this.busy = false;
    this.hasFit = true;

    this.img = root.querySelector('[data-wvc-img]');
    this.frame = root.querySelector('[data-wvc-frame]');
    this.thumbs = root.querySelector('[data-wvc-thumbs]');
    this.count = root.querySelector('[data-wvc-count]');
    this.bar = root.querySelector('[data-wvc-bar]');
    this.addButtons = root.querySelectorAll('[data-wvc-add]');
    this.errorEl = root.querySelector('[data-wvc-error]');
    this.errorCart = root.querySelector('[data-wvc-error-cart]');
    this.dialog = root.querySelector('[data-wvc-dialog]');
    this.backdrop = root.querySelector('[data-wvc-dialog-backdrop]');
    this.posted = root.querySelector('[data-wvc-store-posted]');
    this.restoreAfterPost();
    this.initPromo();
    this.rows = [];
    this.total = 0;

    this.bind();
    this.applyUrl();
    this.update({ fromInit: true });
    this.observeBar();
    this.bindDialog();

    // Terug met de browserknop vanuit de winkelwagen: de pagina komt uit de cache terug in de
    // toestand "Bezig met toevoegen…". Zet de knoppen dan weer klaar.
    var self = this;
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      self.setBusy(false);
      self.clearError();
      self.update({ fromInit: true });
    });
  }

  /* ---------- Actie (bijv. Black Friday) ---------- */

  // De server zet de actie aan binnen de periode; hier nog eens controleren met de klok van de bezoeker,
  // want een pagina kan even in de cache staan. Buiten de periode: actieprijzen, labels en actiebuilds weg.
  Configurator.prototype.initPromo = function () {
    var d = this.root.dataset;
    var on = d.promo === '1';
    if (on && d.promoTest !== '1') {
      var now = Date.now() / 1000;
      var st = parseInt(d.promoStart, 10) || 0;
      var en = parseInt(d.promoEnd, 10) || 0;
      if (st && en && (now < st || now > en)) on = false;
    }
    this.promoOn = on;
    if (on) return;
    this.root.classList.add('wvc--nopromo');
    var self = this;
    this.qa('[data-wvc-extra-check]').forEach(function (c) {
      if (!parseInt(c.dataset.promoOff, 10)) return;
      c.dataset.promoOff = '0';
      var wrap = c.closest('[data-wvc-extra]');
      var priceEl = wrap && wrap.querySelector('[data-wvc-extra-price]');
      var qty = self.priceQty(c);
      if (priceEl) priceEl.textContent = (priceEl.dataset.prefix || '') + formatMoney((parseInt(c.dataset.price, 10) || 0) * qty, self.data.money);
    });
    this.qa('.wvc-build[data-promo-only] [data-wvc-build]').forEach(function (i) { i.checked = false; });
  };

  // Prijs per stuk, met actiekorting als die geldt
  Configurator.prototype.unitPrice = function (c) {
    var price = parseInt(c.dataset.price, 10) || 0;
    var off = this.promoOn ? (parseInt(c.dataset.promoOff, 10) || 0) : 0;
    // Actieprijs geldt niet bij deze build (bijv. alleen Force en hoger)
    var wrap = off ? c.closest('[data-wvc-extra]') : null;
    if (wrap && wrap.classList.contains('is-promo-off')) off = 0;
    return Math.max(0, price - off);
  };

  // Aantal dat bij een upgrade in beeld staat: met aantalkiezer de prijs per stuk, anders het vaste aantal (bijv. 2 banden)
  Configurator.prototype.priceQty = function (c) {
    var wrap = c.closest('[data-wvc-extra]');
    if (wrap && wrap.querySelector('[data-wvc-qty]')) return 1;
    return parseInt(c.dataset.qty, 10) || 1;
  };

  // Hoogste aantal voor een upgrade met aantalkiezer: per model (bijv. NS1: 2, GS1: 3), nooit meer dan de voorraad
  Configurator.prototype.qtyMax = function (wrap, c) {
    var max = parseInt(wrap.dataset.max, 10) || 1;
    var model = this.model();
    (wrap.dataset.maxModels || '').split(',').forEach(function (pair) {
      var bits = pair.split(':');
      if (bits[0] === model) max = parseInt(bits[1], 10) || max;
    });
    var inv = c.dataset.inv;
    if (inv !== undefined && inv !== '') max = Math.min(max, parseInt(inv, 10) || 1);
    return Math.max(1, max);
  };

  Configurator.prototype.syncQty = function (wrap) {
    var c = wrap.querySelector('[data-wvc-extra-check]');
    var box = wrap.querySelector('[data-wvc-qty]');
    if (!c || !box) return;
    var max = this.qtyMax(wrap, c);
    var q = c.checked ? Math.min(Math.max(1, parseInt(c.dataset.qty, 10) || 1), max) : 1;
    c.dataset.qty = String(q);
    var val = box.querySelector('[data-wvc-qty-val]');
    if (val) val.textContent = q;
    var plus = box.querySelector('[data-wvc-qty-step="1"]');
    if (plus) plus.disabled = q >= max;
  };

  // Naam met aantal, voor deeltekst en pop-up
  Configurator.prototype.extraName = function (c) {
    var qty = parseInt(c.dataset.qty, 10) || 1;
    return (qty > 1 ? qty + '× ' : '') + c.dataset.title;
  };

  Configurator.prototype.q = function (sel) {
    return this.root.querySelector(sel);
  };

  Configurator.prototype.qa = function (sel) {
    return Array.prototype.slice.call(this.root.querySelectorAll(sel));
  };

  /* ---------- Huidige keuzes ---------- */

  Configurator.prototype.model = function () {
    var el = this.q('[data-wvc-model]:checked') || this.q('[data-wvc-model]');
    return el ? el.value : '';
  };

  Configurator.prototype.buildInput = function () {
    var model = this.model();
    var promoOn = this.promoOn;
    var inputs = this.qa('[data-wvc-build]').filter(function (i) {
      return i.dataset.model === model && (promoOn || !i.closest('[data-promo-only]'));
    });
    var checked = inputs.filter(function (i) { return i.checked; })[0];
    if (!checked && inputs[0]) {
      inputs[0].checked = true;
      checked = inputs[0];
    }
    return checked || null;
  };

  Configurator.prototype.colorInput = function (buildKey) {
    var group = this.root.querySelector('.wvc-colors[data-wvc-for="' + buildKey + '"]');
    if (!group) return null;
    var checked = group.querySelector('[data-wvc-color]:checked');
    if (!checked) {
      checked = group.querySelector('[data-wvc-color]');
      if (checked) checked.checked = true;
    }
    return checked;
  };

  Configurator.prototype.sizeGroup = function (handle) {
    return this.root.querySelector('.wvc-sizes[data-wvc-for="' + handle + '"]');
  };

  Configurator.prototype.sizeInput = function (handle) {
    var group = this.sizeGroup(handle);
    return group ? group.querySelector('[data-wvc-size]:checked') : null;
  };

  /* ---------- Events ---------- */

  Configurator.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('change', function (event) {
      var t = event.target;
      if (t.matches('[data-wvc-size]')) {
        self.chosenSize = t.dataset.size;
      }
      if (t.matches('[data-wvc-extra-variant]')) {
        self.syncExtraVariant(t);
      }
      if (t.matches('[data-wvc-choice-opt]')) {
        var part = t.closest('[data-wvc-choice]');
        if (part) part.dataset.touched = '1';
      }
      if (t.matches('[data-wvc-axis-opt]')) {
        self.pickCombo(t.closest('[data-wvc-choice]'), t.dataset.wvcAxisOpt);
      }
      if (t.matches('[data-wvc-model], [data-wvc-build], [data-wvc-color], [data-wvc-size], [data-wvc-extra-check], [data-wvc-extra-variant], [data-wvc-part-std], [data-wvc-choice-opt], [data-wvc-axis-opt]')) {
        self.clearError();
        self.update();
      }
    });

    // Aantalkiezer bij upgrades: − bij 1 haalt de upgrade weg
    this.root.addEventListener('click', function (event) {
      var b = event.target.closest('[data-wvc-qty-step]');
      if (!b) return;
      var wrap = b.closest('[data-wvc-extra]');
      var c = wrap && wrap.querySelector('[data-wvc-extra-check]');
      if (!c || !c.checked) return;
      var q = (parseInt(c.dataset.qty, 10) || 1) + parseInt(b.dataset.wvcQtyStep, 10);
      if (q < 1) {
        c.checked = false;
        c.dataset.qty = '1';
        c.focus({ preventScroll: true });
      } else {
        c.dataset.qty = String(Math.min(q, self.qtyMax(wrap, c)));
      }
      self.clearError();
      self.update();
    });

    var prev = this.q('[data-wvc-prev]');
    var next = this.q('[data-wvc-next]');
    if (prev) prev.addEventListener('click', function () { self.step(-1); });
    if (next) next.addEventListener('click', function () { self.step(1); });

    if (this.frame) {
      this.frame.addEventListener('keydown', function (event) {
        if (event.target !== self.frame) return;
        if (event.key === 'ArrowLeft') { event.preventDefault(); self.step(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); self.step(1); }
      });

      var startX = null;
      this.frame.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse') return;
        startX = event.clientX;
      });
      this.frame.addEventListener('pointerup', function (event) {
        if (startX === null) return;
        var dx = event.clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) self.step(dx < 0 ? 1 : -1);
      });
      this.frame.addEventListener('pointercancel', function () { startX = null; });
    }

    this.addButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { self.addToCart(); });
    });

    this.qa('[data-wvc-testride]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        self.openDialog(link, 'testride');
      });
    });
    this.qa('[data-wvc-ask]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        self.openDialog(link, link.getAttribute('data-wvc-ask'));
      });
    });
    this.qa('[data-wvc-share]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.openDialog(btn); });
    });

    var tablist = this.q('[data-wvc-xtabs]');
    if (tablist) {
      tablist.addEventListener('click', function (event) {
        var tab = event.target.closest('[data-wvc-xtab]');
        if (tab) self.selectTab(tab, false);
      });
      tablist.addEventListener('keydown', function (event) {
        var tabs = self.visibleTabs();
        var i = tabs.indexOf(document.activeElement);
        if (i === -1) return;
        var to = null;
        if (event.key === 'ArrowRight') to = tabs[(i + 1) % tabs.length];
        if (event.key === 'ArrowLeft') to = tabs[(i - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') to = tabs[0];
        if (event.key === 'End') to = tabs[tabs.length - 1];
        if (to) {
          event.preventDefault();
          self.selectTab(to, true);
        }
      });
    }
  };

  /* ---------- Upgrades: tabs per categorie ---------- */

  Configurator.prototype.visibleTabs = function () {
    return this.qa('[data-wvc-xtab]').filter(function (t) { return !t.hidden; });
  };

  Configurator.prototype.selectTab = function (tab, focus) {
    var self = this;
    this.qa('[data-wvc-xtab]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = self.root.querySelector('[data-wvc-xpanel="' + t.dataset.wvcXtab + '"]');
      if (panel) panel.hidden = !on;
    });
    if (focus) tab.focus();
    if (tab.scrollIntoView && tab.parentElement.scrollWidth > tab.parentElement.clientWidth) {
      tab.parentElement.scrollTo({ left: tab.offsetLeft - 16, behavior: 'smooth' });
    }
    var grid = this.root.querySelector('[data-wvc-xpanel="' + tab.dataset.wvcXtab + '"] .wvc-xgrid');
    if (grid) grid.scrollLeft = 0;
  };

  Configurator.prototype.updateTabs = function () {
    var self = this;
    var active = null;
    var total = 0;
    var count = 0;
    this.qa('[data-wvc-xtab]').forEach(function (tab) {
      var panel = self.root.querySelector('[data-wvc-xpanel="' + tab.dataset.wvcXtab + '"]');
      var tiles = panel ? Array.prototype.slice.call(panel.querySelectorAll('[data-wvc-extra]:not([hidden])')) : [];
      tab.hidden = tiles.length === 0;
      var n = 0;
      tiles.forEach(function (tile) {
        var c = tile.querySelector('[data-wvc-extra-check]');
        if (c && c.checked) {
          var q = parseInt(c.dataset.qty, 10) || 1;
          n += tile.querySelector('[data-wvc-qty]') ? q : 1;
          total += self.unitPrice(c) * q;
        }
      });
      count += n;
      var badge = tab.querySelector('[data-wvc-xtab-count]');
      if (badge) {
        badge.textContent = n;
        badge.hidden = n === 0;
      }
      if (!tab.hidden && tab.getAttribute('aria-selected') === 'true') active = tab;
    });
    if (!active) {
      var first = this.visibleTabs()[0];
      if (first) this.selectTab(first, false);
    }
    var value = count > 0 ? count + ' ' + (this.labels.selected || '') + ' · + ' + formatMoney(total, this.data.money) : '';
    this.setText('[data-wvc-extras-value]', value.trim());
  };

  Configurator.prototype.syncExtraVariant = function (select, noCheck) {
    var wrap = select.closest('[data-wvc-extra]');
    var check = wrap && wrap.querySelector('[data-wvc-extra-check]');
    var opt = select.options[select.selectedIndex];
    if (!check || !opt) return;
    check.value = opt.value;
    check.dataset.price = opt.dataset.price;
    check.dataset.variantTitle = opt.dataset.title || '';
    if ('inv' in opt.dataset) check.dataset.inv = opt.dataset.inv;
    var qty = this.priceQty(check);
    var priceEl = wrap.querySelector('[data-wvc-extra-price]');
    if (priceEl) priceEl.textContent = (priceEl.dataset.prefix || '') + formatMoney(this.unitPrice(check) * qty, this.data.money);
    var wasEl = wrap.querySelector('[data-wvc-extra-was]');
    if (wasEl) wasEl.textContent = formatMoney(parseInt(opt.dataset.price, 10) * qty, this.data.money);
    if (!noCheck) check.checked = true;
  };

  /* ---------- Bijwerken ---------- */

  Configurator.prototype.update = function (opts) {
    opts = opts || {};
    var model = this.model();

    var promoOn = this.promoOn;
    this.qa('.wvc-build').forEach(function (el) {
      el.hidden = el.dataset.wvcFor !== model || (!promoOn && el.hasAttribute('data-promo-only'));
    });

    var build = this.buildInput();
    var buildKey = build ? build.value : '';

    this.qa('.wvc-colors').forEach(function (el) {
      el.hidden = el.dataset.wvcFor !== buildKey;
    });
    this.qa('.wvc-specs__list').forEach(function (el) {
      el.hidden = el.dataset.wvcFor !== buildKey;
    });
    this.qa('[data-wvc-more-for]').forEach(function (el) {
      el.hidden = el.dataset.wvcMoreFor !== buildKey;
    });

    var color = this.colorInput(buildKey);
    var handle = color ? color.value : '';

    var self = this;
    this.qa('.wvc-sizes').forEach(function (el) {
      el.hidden = el.dataset.wvcFor !== handle;
    });

    // Gekozen maat meenemen naar een andere kleur of build, als die daar beschikbaar is
    var size = this.sizeInput(handle);
    if (!size && this.chosenSize) {
      var group = this.sizeGroup(handle);
      var match = group && Array.prototype.slice.call(group.querySelectorAll('[data-wvc-size]')).filter(function (i) {
        return i.dataset.size === self.chosenSize && !i.disabled;
      })[0];
      if (match) {
        match.checked = true;
        size = match;
      } else {
        this.qa('[data-wvc-size]:checked').forEach(function (i) { i.checked = false; });
      }
    }

    // Upgrades en onderdelen die niet bij dit model / deze build / deze aandrijving passen: verbergen en uitzetten
    var bshort = build ? build.dataset.key : '';
    var drive = build ? (build.dataset.drive || '') : '';
    this.qa('[data-wvc-extra]').forEach(function (el) {
      var list = (el.dataset.models || '').split(',').filter(Boolean);
      var skip = (el.dataset.skip || '').split(',').filter(Boolean);
      var od = el.dataset.drive || '';
      var show = (list.length === 0 || list.indexOf(model) !== -1) && skip.indexOf(bshort) === -1 && (!od || !drive || od === drive);
      el.hidden = !show;
      var c = el.querySelector('[data-wvc-extra-check]');
      if (!show && c) c.checked = false;
      // Actieprijs alleen bij de builds uit de blokinstelling; anders normale prijs en de uitleg
      if (c && parseInt(c.dataset.promoOff, 10)) {
        var pbs = (el.dataset.promoBuilds || '').split(',').filter(Boolean);
        var pOff = pbs.length > 0 && pbs.indexOf(bshort) === -1;
        if (el.classList.contains('is-promo-off') !== pOff) {
          el.classList.toggle('is-promo-off', pOff);
          var pEl = el.querySelector('[data-wvc-extra-price]');
          if (pEl) pEl.textContent = (pEl.dataset.prefix || '') + formatMoney(self.unitPrice(c) * self.priceQty(c), self.data.money);
        }
      }
      // Varianten met de verkeerde naafbody (XDR/Shimano) uitschakelen
      var sel = el.querySelector('[data-wvc-extra-variant]');
      if (show && sel) {
        var changed = false;
        Array.prototype.forEach.call(sel.options, function (o) {
          if (!('available' in o.dataset)) o.dataset.available = o.disabled ? '0' : '1';
          var bad = !!(drive && o.dataset.drive && o.dataset.drive !== drive);
          o.disabled = bad || o.dataset.available === '0';
        });
        var ok = Array.prototype.filter.call(sel.options, function (o) { return !o.disabled; })[0];
        if (sel.options[sel.selectedIndex] && sel.options[sel.selectedIndex].disabled && ok) {
          sel.value = ok.value;
          changed = true;
        }
        if (changed) self.syncExtraVariant(sel, true);
        // Geen enkele passende variant leverbaar (bijv. alleen Shimano op voorraad bij een SRAM-build): niet kiesbaar
        if (c) {
          if (!('origDisabled' in c.dataset)) c.dataset.origDisabled = c.disabled ? '1' : '0';
          c.disabled = !ok || c.dataset.origDisabled === '1';
          if (c.disabled) c.checked = false;
        }
      }
      self.syncQty(el);
    });
    this.updateTabs();
    this.updateParts(model, bshort, size);

    // Bike fit hoort niet bij elke build (bijv. framesets)
    this.hasFit = !build || build.dataset.fit !== '0';
    var fitStep = this.q('[data-wvc-fit-step]');
    if (fitStep) fitStep.hidden = !this.hasFit;
    var hasFit = this.hasFit;
    this.qa('[data-wvc-bar-fit]').forEach(function (el) { el.hidden = !hasFit; });

    // Teksten
    var modelInput = this.q('[data-wvc-model]:checked');
    var modelName = modelInput ? modelInput.dataset.name : '';
    var buildName = build ? build.dataset.name : '';
    var colorName = color ? color.dataset.name : '';
    this.setText('[data-wvc-stage-model]', modelName);
    this.setText('[data-wvc-stage-build]', buildName);
    this.setText('[data-wvc-stage-color]', colorName);
    var colorOut = color && color.dataset.out === '1' && this.labels.soldout ? ' · ' + this.labels.soldout : '';
    this.setText('[data-wvc-color-name]', colorName + colorOut);
    this.setText('[data-wvc-size-name]', size ? size.dataset.size : '');
    this.setText('[data-wvc-bar-name]', [this.data.brand, modelName, buildName].join(' ').trim());

    var dot = this.q('[data-wvc-stage-dot]');
    var label = color ? this.root.querySelector('label[for="' + color.id + '"]') : null;
    if (dot && label) dot.style.setProperty('--wvc-sw', label.style.getPropertyValue('--wvc-sw'));

    var link = this.q('[data-wvc-product-link]');
    if (link && color) link.href = color.dataset.url;

    // Niet op voorraad in deze kleur
    var group2 = this.sizeGroup(handle);
    var anyAvailable = group2 ? !!group2.querySelector('[data-wvc-size]:not(:disabled)') : false;
    var soldout = this.q('[data-wvc-soldout]');
    if (soldout) soldout.hidden = anyAvailable;

    // Foto's
    if (handle !== this.currentHandle) {
      this.currentHandle = handle;
      this.imageIndex = 0;
      this.renderThumbs();
      this.showImage(0, opts.fromInit);
      if (build) this.preloadColors(buildKey);
    }

    this.renderSummary(build, color, size, anyAvailable);
    if (!opts.fromInit) this.writeUrl(model, build, color, size);
  };

  /* ---------- Pas hem aan ---------- */

  Configurator.prototype.updateParts = function (model, bshort, size) {
    var self = this;
    var labels = this.labels;
    var sizeLabel = size ? size.dataset.size : '';
    var build = this.buildInput();
    var std = (build && this.data.builds && this.data.builds[build.value] && this.data.builds[build.value].std) || {};
    var count = 0;

    // Maatkeuzes (cockpit, cranklengte): standaard volgt de maat, tot de klant zelf iets kiest
    this.qa('[data-wvc-choice]').forEach(function (d) {
      var list = (d.dataset.models || '').split(',').filter(Boolean);
      var skip = (d.dataset.skip || '').split(',').filter(Boolean);
      var show = (list.length === 0 || list.indexOf(model) !== -1) && skip.indexOf(bshort) === -1;
      d.hidden = !show;
      var map = {};
      try { map = JSON.parse(d.dataset.std || '{}'); } catch (e) { map = {}; }
      var stdVal = sizeLabel ? (map[sizeLabel] || '') : '';
      var opts = Array.prototype.slice.call(d.querySelectorAll('[data-wvc-choice-opt]'));
      opts.forEach(function (o) {
        var chip = o.closest('.wvc-chip');
        if (chip) chip.classList.toggle('is-std', !!stdVal && o.value === stdVal);
        if (d.dataset.touched !== '1') o.checked = !!stdVal && o.value === stdVal;
      });
      var cur = d.querySelector('[data-wvc-choice-opt]:checked');
      if (d.classList.contains('wvc-part--grid')) {
        // Eerder gekozen maat die bij deze fietsmaat niet leverbaar is: terug naar de standaard
        if (cur && !comboOk(cur, stdVal)) {
          d.dataset.touched = '0';
          opts.forEach(function (o) { o.checked = !!stdVal && o.value === stdVal; });
          cur = d.querySelector('[data-wvc-choice-opt]:checked');
        }
        self.syncAxes(d, stdVal, cur);
      }
      var changed = show && !!cur && cur.value !== stdVal;
      d.dataset.changed = changed ? '1' : '0';
      if (changed) count += 1;
      var text = cur ? cur.value + (cur.value === stdVal ? ' (' + labels.stdShort + ')' : '') : (sizeLabel ? labels.standard : labels.chooseSize);
      var value = d.querySelector('[data-wvc-part-value]');
      if (value) value.textContent = text;
      d.classList.toggle('is-changed', changed);
    });

    // Onderdeel-upgrades (wielen, zadel, banden): standaard of één upgrade
    this.qa('[data-wvc-partcat]').forEach(function (d) {
      var any = !!d.querySelector('[data-wvc-extra]:not([hidden])');
      d.hidden = !any;
      var stdRadio = d.querySelector('[data-wvc-part-std]');
      var chosen = d.querySelector('[data-wvc-extra]:not([hidden]) [data-wvc-extra-check]:checked');
      if (!chosen && stdRadio) stdRadio.checked = true;
      var stdName = std[d.dataset.name] || '';
      var stdEl = d.querySelector('[data-wvc-part-stdname]');
      if (stdEl) stdEl.textContent = stdName;
      var value = d.querySelector('[data-wvc-part-value]');
      if (value) value.textContent = chosen ? chosen.dataset.title : labels.standard + (stdName ? ': ' + stdName : '');
      if (any && chosen) count += 1;
      d.classList.toggle('is-changed', any && !!chosen);
    });

    var step = this.q('[data-wvc-parts-step]');
    if (step) step.hidden = !this.q('.wvc-part:not([hidden])');
    this.setText('[data-wvc-parts-value]', count ? count + ' ' + (labels.customized || '') : '');
  };

  /* Maatkeuze met twee maten (cockpit): rijen breedte en lengte. De echte keuze is een verborgen radio per combinatie. */

  // Leverbaar: variant op voorraad (of geen artikel gekoppeld), of de standaard voor de gekozen maat (zit al op de fiets)
  function comboOk(o, stdVal) {
    return o.dataset.avail === '1' || o.value === stdVal;
  }

  Configurator.prototype.syncAxes = function (d, stdVal, cur) {
    var combos = Array.prototype.slice.call(d.querySelectorAll('[data-wvc-choice-opt]'));
    var std = combos.filter(function (o) { return o.value === stdVal; })[0];
    ['a', 'b'].forEach(function (ax) {
      Array.prototype.forEach.call(d.querySelectorAll('[data-wvc-axis-opt="' + ax + '"]'), function (r) {
        var v = r.value;
        r.checked = !!cur && cur.dataset[ax] === v;
        var opt = r.closest('.wvc-seg__opt');
        if (opt) opt.classList.toggle('is-std', !!std && std.dataset[ax] === v);
        var a = ax === 'b' && cur ? cur.dataset.a : null;
        r.disabled = !combos.some(function (o) {
          return o.dataset[ax] === v && (a === null || o.dataset.a === a) && comboOk(o, stdVal);
        });
      });
    });
  };

  // Klant kiest een breedte of lengte: zoek de combinatie; bestaat die niet (of niet op voorraad), dan de dichtstbijzijnde andere maat
  Configurator.prototype.pickCombo = function (d, changedAxis) {
    if (!d) return;
    var map = {};
    try { map = JSON.parse(d.dataset.std || '{}'); } catch (e) { map = {}; }
    var size = this.sizeInput(this.currentHandle);
    var stdVal = size ? (map[size.dataset.size] || '') : '';
    var combos = Array.prototype.slice.call(d.querySelectorAll('[data-wvc-choice-opt]'));
    var cur = d.querySelector('[data-wvc-choice-opt]:checked') || combos.filter(function (o) { return o.value === stdVal; })[0];
    var ra = d.querySelector('[data-wvc-axis-opt="a"]:checked');
    var rb = d.querySelector('[data-wvc-axis-opt="b"]:checked');
    var want = { a: ra ? ra.value : (cur ? cur.dataset.a : ''), b: rb ? rb.value : (cur ? cur.dataset.b : '') };
    var other = changedAxis === 'a' ? 'b' : 'a';
    var hit = combos.filter(function (o) { return o.dataset.a === want.a && o.dataset.b === want.b && comboOk(o, stdVal); })[0];
    if (!hit) {
      var target = parseFloat(want[other]);
      var list = combos.filter(function (o) { return o.dataset[changedAxis] === want[changedAxis] && comboOk(o, stdVal); });
      if (!isNaN(target)) {
        list.sort(function (x, y) { return Math.abs(parseFloat(x.dataset[other]) - target) - Math.abs(parseFloat(y.dataset[other]) - target); });
      }
      hit = list[0];
    }
    if (hit) {
      hit.checked = true;
      d.dataset.touched = '1';
    }
  };

  // Gekozen maatkeuzes die afwijken van de standaard: [naam, waarde]
  Configurator.prototype.choiceChanges = function () {
    return this.qa('[data-wvc-choice]:not([hidden])').filter(function (d) {
      return d.dataset.changed === '1';
    }).map(function (d) {
      var cur = d.querySelector('[data-wvc-choice-opt]:checked');
      return [d.dataset.name, cur ? cur.value : ''];
    });
  };

  Configurator.prototype.setText = function (sel, text) {
    this.qa(sel).forEach(function (el) { el.textContent = text || ''; });
  };

  /* ---------- Foto's ---------- */

  Configurator.prototype.images = function () {
    var p = this.data.products[this.currentHandle];
    return p && p.i ? p.i : [];
  };

  Configurator.prototype.showImage = function (index, instant) {
    var imgs = this.images();
    if (!this.img || imgs.length === 0) return;
    var i = ((index % imgs.length) + imgs.length) % imgs.length;
    this.imageIndex = i;
    var data = imgs[i];
    var img = this.img;
    var color = this.q('.wvc-colors:not([hidden]) [data-wvc-color]:checked');
    var alt = color ? color.dataset.title + ' – ' + color.dataset.name : '';

    var apply = function () {
      img.srcset = data.m + ' 600w, ' + data.s + ' 1000w';
      img.src = data.s;
      img.alt = alt;
      img.classList.toggle('is-contain', Math.abs((data.r || 1.5) - 1.5) > 0.08);
    };

    if (instant || img.src === data.s) {
      apply();
    } else {
      img.classList.add('is-loading');
      var done = function () {
        img.removeEventListener('load', done);
        img.removeEventListener('error', done);
        requestAnimationFrame(function () { img.classList.remove('is-loading'); });
      };
      img.addEventListener('load', done);
      img.addEventListener('error', done);
      window.setTimeout(apply, 120);
      window.setTimeout(done, 1500);
    }

    if (this.count) this.count.textContent = imgs.length > 1 ? (i + 1) + ' / ' + imgs.length : '';
    this.qa('.wvc-thumb').forEach(function (t, n) {
      t.setAttribute('aria-current', n === i ? 'true' : 'false');
    });
    var active = this.thumbs && this.thumbs.children[i];
    if (active && this.thumbs.scrollWidth > this.thumbs.clientWidth) {
      this.thumbs.scrollTo({ left: active.offsetLeft - this.thumbs.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
    }
    var nav = this.qa('.wvc-stage__nav');
    nav.forEach(function (b) { b.hidden = imgs.length < 2; });
  };

  Configurator.prototype.step = function (dir) {
    this.showImage(this.imageIndex + dir);
  };

  Configurator.prototype.renderThumbs = function () {
    if (!this.thumbs) return;
    var self = this;
    var imgs = this.images();
    while (this.thumbs.firstChild) this.thumbs.removeChild(this.thumbs.firstChild);
    if (imgs.length < 2) return;
    imgs.forEach(function (data, n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wvc-thumb';
      b.setAttribute('aria-label', (n + 1) + ' / ' + imgs.length);
      var im = document.createElement('img');
      im.src = data.t;
      im.alt = '';
      im.loading = 'lazy';
      im.width = 180;
      im.height = 120;
      b.appendChild(im);
      b.addEventListener('click', function () { self.showImage(n); });
      self.thumbs.appendChild(b);
    });
  };

  Configurator.prototype.preloadColors = function (buildKey) {
    var self = this;
    var group = this.root.querySelector('.wvc-colors[data-wvc-for="' + buildKey + '"]');
    if (!group) return;
    group.querySelectorAll('[data-wvc-color]').forEach(function (input) {
      var p = self.data.products[input.value];
      if (p && p.i && p.i[0]) {
        var im = new Image();
        im.src = p.i[0].s;
      }
    });
  };

  /* ---------- Overzicht en totaal ---------- */

  Configurator.prototype.selectedExtras = function () {
    return this.qa('[data-wvc-extra]:not([hidden]) [data-wvc-extra-check]:checked');
  };

  Configurator.prototype.renderSummary = function (build, color, size, anyAvailable) {
    var money = this.data.money;
    var lines = this.q('[data-wvc-lines]');
    var bikePrice = size ? parseInt(size.dataset.price, 10) : (color ? parseInt(color.dataset.price, 10) : 0);
    var total = bikePrice;

    var rows = [];
    var modelInput = this.q('[data-wvc-model]:checked');
    var bikeLabel = [this.data.brand, modelInput ? modelInput.dataset.name : '', build ? build.dataset.name : ''].join(' ').trim();
    if (color) bikeLabel += ' · ' + color.dataset.name;
    if (size) bikeLabel += ' · ' + size.dataset.size;
    rows.push([bikeLabel, formatMoney(bikePrice, money), '']);
    if (this.hasFit) rows.push([this.data.fit.title || '', this.data.fit.badge || '', 'wvc-summary__line--fit']);

    var free = this.labels.free || '';
    this.choiceChanges().forEach(function (ch) {
      rows.push([ch[0] + ': ' + ch[1], free, 'wvc-summary__line--fit']);
    });

    var self = this;
    var anyPromo = false;
    this.selectedExtras().forEach(function (c) {
      var qty = parseInt(c.dataset.qty, 10) || 1;
      var unit = self.unitPrice(c);
      var isPromo = unit < (parseInt(c.dataset.price, 10) || 0);
      if (isPromo) anyPromo = true;
      var price = unit * qty;
      total += price;
      var name = c.dataset.title + (c.dataset.variantTitle ? ' · ' + c.dataset.variantTitle : '') + (qty > 1 ? ' (' + qty + '×)' : '') + (isPromo && self.labels.promoLabel ? ' · ' + self.labels.promoLabel : '');
      rows.push([name, formatMoney(price, money), isPromo ? 'wvc-summary__line--promo' : '']);
    });
    var note = this.q('[data-wvc-promo-note]');
    if (note) note.hidden = !anyPromo;

    if (lines) {
      while (lines.firstChild) lines.removeChild(lines.firstChild);
      rows.forEach(function (r) {
        var li = document.createElement('li');
        li.className = 'wvc-summary__line' + (r[2] ? ' ' + r[2] : '');
        var a = document.createElement('span');
        a.textContent = r[0];
        var b = document.createElement('span');
        b.textContent = r[1];
        li.appendChild(a);
        li.appendChild(b);
        lines.appendChild(li);
      });
    }

    this.rows = rows;
    this.total = total;
    this.setText('[data-wvc-total]', formatMoney(total, money));

    var label;
    var disabled;
    if (!anyAvailable) {
      label = this.labels.ctaSoldout;
      disabled = true;
    } else if (!size) {
      label = this.labels.ctaSize;
      disabled = false; // klikbaar: brengt je naar de maatkeuze
    } else {
      label = this.labels.cta;
      disabled = false;
    }
    this.addButtons.forEach(function (btn) {
      if (btn.classList.contains('is-loading')) return;
      btn.textContent = label;
      btn.disabled = disabled;
      btn.dataset.needsSize = size ? 'false' : 'true';
    });
  };

  /* ---------- Winkelwagen ---------- */

  Configurator.prototype.clearError = function () {
    if (this.errorEl) {
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }
    if (this.errorCart) this.errorCart.hidden = true;
  };

  Configurator.prototype.showError = function (msg, withCartLink) {
    if (!this.errorEl) return;
    this.errorEl.textContent = msg || this.labels.error;
    this.errorEl.hidden = false;
    if (this.errorCart) this.errorCart.hidden = !withCartLink;
    // De melding staat bij het overzicht; breng hem in beeld als je via de balk klikte
    var r = this.errorEl.getBoundingClientRect();
    if (r.top < 80 || r.bottom > window.innerHeight - 90) {
      this.errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  Configurator.prototype.setBusy = function (on) {
    var self = this;
    this.busy = on;
    this.addButtons.forEach(function (btn) {
      btn.classList.toggle('is-loading', on);
      if (on) btn.textContent = self.labels.adding;
    });
    if (!on) this.update({ fromInit: true });
  };

  Configurator.prototype.cartBase = function () {
    return this.root.dataset.cartUrl || '/cart';
  };

  // fetch met tijdslimiet; geeft de JSON terug of gooit een fout met status
  Configurator.prototype.request = function (url, options) {
    options = options || {};
    var ctrl = 'AbortController' in window ? new AbortController() : null;
    var timer = ctrl ? window.setTimeout(function () { ctrl.abort(); }, 20000) : null;
    if (ctrl) options.signal = ctrl.signal;
    return fetch(url, options).then(function (res) {
      if (timer) window.clearTimeout(timer);
      return res.json().catch(function () { return {}; }).then(function (body) {
        if (!res.ok) {
          var err = new Error((body && (body.description || body.message)) || '');
          err.status = res.status;
          throw err;
        }
        return body;
      });
    }, function (err) {
      if (timer) window.clearTimeout(timer);
      throw err;
    });
  };

  Configurator.prototype.getCart = function () {
    return this.request(this.cartBase() + '.js', { headers: { Accept: 'application/json' } });
  };

  Configurator.prototype.postAdd = function (items) {
    var url = (this.root.dataset.cartAdd || '/cart/add') + '.js';
    return this.request(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items.map(function (i) { return { id: i.id, quantity: i.quantity, properties: i.properties }; }) })
    });
  };

  function qtyInCart(cart, id) {
    return ((cart && cart.items) || []).reduce(function (n, line) {
      return n + (line.variant_id === id ? line.quantity : 0);
    }, 0);
  }

  Configurator.prototype.addToCart = function () {
    if (this.busy) return;
    var handle = this.currentHandle;
    var size = this.sizeInput(handle);
    if (!size) {
      var set = this.q('.wvc-sizeset');
      if (set) {
        set.scrollIntoView({ behavior: 'smooth', block: 'center' });
        set.classList.remove('is-attention');
        void set.offsetWidth;
        set.classList.add('is-attention');
        var first = set.querySelector('.wvc-sizes:not([hidden]) [data-wvc-size]:not(:disabled)');
        if (first) window.setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
      }
      return;
    }

    var build = this.buildInput();
    var color = this.colorInput(build ? build.value : '');
    var modelInput = this.q('[data-wvc-model]:checked');
    var configName = [this.data.brand, modelInput ? modelInput.dataset.name : '', build ? build.dataset.name : '', color ? color.dataset.name : '', size.dataset.size].join(' ').trim();

    var bikeProps = {};
    if (this.hasFit && this.data.fit && this.data.fit.prop) bikeProps[this.data.fit.prop] = this.data.fit.value || '';
    this.choiceChanges().forEach(function (ch) { bikeProps[ch[0]] = ch[1]; });
    bikeProps._Configurator = configName;

    var items = [{ id: parseInt(size.value, 10), quantity: 1, properties: bikeProps, name: configName, bike: true }];
    this.selectedExtras().forEach(function (c) {
      items.push({
        id: parseInt(c.value, 10),
        quantity: parseInt(c.dataset.qty, 10) || 1,
        properties: { _Configurator: configName },
        name: c.dataset.title + (c.dataset.variantTitle ? ' (' + c.dataset.variantTitle + ')' : '')
      });
    });

    // Maatkeuze met artikel (bijv. cockpit): bij een afwijkende keuze de variant als eigen regel
    this.qa('[data-wvc-choice][data-cart="1"]:not([hidden])').forEach(function (d) {
      if (d.dataset.changed !== '1') return;
      var cur = d.querySelector('[data-wvc-choice-opt]:checked');
      var vid = cur ? parseInt(cur.dataset.variant, 10) : 0;
      if (vid) items.push({ id: vid, quantity: 1, properties: { _Configurator: configName }, name: d.dataset.name + ': ' + cur.value });
    });

    var self = this;
    var before = null;
    this.clearError();
    this.setBusy(true);

    this.getCart()
      .then(function (cart) {
        before = cart;
        return self.postAdd(items);
      })
      .then(function () {
        window.location.href = self.cartBase();
      })
      .catch(function (err) {
        // 422 = Shopify weigert (meestal: niet genoeg voorraad, bijv. omdat het al in je winkelwagen zit).
        // Kijk wat er wél is toegevoegd, probeer de rest los en meld precies wat niet lukte.
        if (err && err.status === 422 && before) return self.recoverAdd(items, before);
        throw err;
      })
      .catch(function (err) {
        self.setBusy(false);
        var msg = err && err.name !== 'AbortError' && err.message ? err.message : self.labels.error;
        self.showError(msg, false);
      });
  };

  Configurator.prototype.recoverAdd = function (items, before) {
    var self = this;
    return this.getCart().then(function (after) {
      var missing = items.filter(function (it) { return qtyInCart(after, it.id) <= qtyInCart(before, it.id); });
      var failed = [];
      return missing.reduce(function (chain, it) {
        return chain.then(function () {
          return self.postAdd([it]).catch(function (e) {
            if (e && e.status === 422) failed.push(it);
            else throw e;
          });
        });
      }, Promise.resolve()).then(function () {
        if (failed.length === 0) {
          window.location.href = self.cartBase();
          return;
        }
        var parts = [];
        var bike = failed.filter(function (it) { return it.bike; })[0];
        var rest = failed.filter(function (it) { return !it.bike; });
        if (bike && qtyInCart(before, bike.id) > 0) {
          parts.push(self.labels.inCart);
        } else if (bike) {
          rest.unshift(bike);
        }
        if (rest.length) {
          parts.push(self.labels.notAdded + ' ' + rest.map(function (it) { return it.name; }).join(', ') + '.');
        }
        if (failed.length < items.length && self.labels.restAdded) parts.push(self.labels.restAdded);
        self.setBusy(false);
        self.showError(parts.join(' '), true);
      });
    });
  };

  /* ---------- Delen en URL ---------- */

  Configurator.prototype.buildUrl = function (model, build, color, size) {
    var params = new URLSearchParams(window.location.search);
    params.delete('contact_posted');
    params.set('model', model);
    if (build) params.set('build', build.dataset.key); else params.delete('build');
    if (color) params.set('kleur', color.dataset.key); else params.delete('kleur');
    if (size) params.set('maat', size.dataset.size); else params.delete('maat');
    var extras = this.selectedExtras().map(function (c) {
      var qty = parseInt(c.dataset.qty, 10) || 1;
      return c.closest('[data-wvc-extra]').querySelector('[data-wvc-qty]') && qty > 1 ? c.value + '~' + qty : c.value;
    });
    if (extras.length) params.set('extra', extras.join('.')); else params.delete('extra');
    var pas = this.qa('[data-wvc-choice]:not([hidden])').filter(function (d) { return d.dataset.touched === '1'; }).map(function (d) {
      var cur = d.querySelector('[data-wvc-choice-opt]:checked');
      return cur ? d.dataset.wvcChoice + '~' + cur.dataset.index : '';
    }).filter(Boolean);
    if (pas.length) params.set('pas', pas.join('.')); else params.delete('pas');
    return window.location.pathname + '?' + params.toString();
  };

  Configurator.prototype.writeUrl = function (model, build, color, size) {
    if (!window.history || !window.history.replaceState) return;
    window.history.replaceState(window.history.state, '', this.buildUrl(model, build, color, size) + window.location.hash);
  };

  // Volledige link naar de huidige configuratie
  Configurator.prototype.shareUrl = function () {
    var build = this.buildInput();
    var color = this.colorInput(build ? build.value : '');
    var size = this.sizeInput(this.currentHandle);
    return window.location.origin + this.buildUrl(this.model(), build, color, size);
  };

  Configurator.prototype.applyUrl = function () {
    var params = new URLSearchParams(window.location.search);
    var model = params.get('model');
    if (!model) return;
    var self = this;
    var m = this.qa('[data-wvc-model]').filter(function (i) { return i.value === model; })[0];
    if (!m) return;
    m.checked = true;

    var buildKey = params.get('build');
    var b = buildKey && this.qa('[data-wvc-build]').filter(function (i) {
      return i.dataset.model === model && i.dataset.key === buildKey;
    })[0];
    if (b) b.checked = true;
    var build = this.buildInput();

    var colorKey = params.get('kleur');
    if (build && colorKey) {
      var group = this.root.querySelector('.wvc-colors[data-wvc-for="' + build.value + '"]');
      var c = group && Array.prototype.slice.call(group.querySelectorAll('[data-wvc-color]')).filter(function (i) {
        return i.dataset.key === colorKey;
      })[0];
      if (c) c.checked = true;
    }
    var color = this.colorInput(build ? build.value : '');

    var sizeLabel = params.get('maat');
    if (color && sizeLabel) {
      var sg = this.sizeGroup(color.value);
      var s = sg && Array.prototype.slice.call(sg.querySelectorAll('[data-wvc-size]')).filter(function (i) {
        return i.dataset.size === sizeLabel && !i.disabled;
      })[0];
      if (s) {
        s.checked = true;
        this.chosenSize = sizeLabel;
      }
    }

    (params.get('pas') || '').split('.').filter(Boolean).forEach(function (pair) {
      var bits = pair.split('~');
      var d = self.root.querySelector('[data-wvc-choice="' + bits[0] + '"]');
      var o = d && d.querySelector('[data-wvc-choice-opt][data-index="' + bits[1] + '"]');
      if (o) {
        o.checked = true;
        d.dataset.touched = '1';
      }
    });

    var extras = (params.get('extra') || '').split('.').filter(Boolean);
    if (extras.length) {
      this.qa('[data-wvc-extra]').forEach(function (wrap) {
        var check = wrap.querySelector('[data-wvc-extra-check]');
        var select = wrap.querySelector('[data-wvc-extra-variant]');
        if (!check || check.disabled) return;
        extras.forEach(function (pair) {
          var bits = pair.split('~');
          var id = bits[0];
          var hit = false;
          if (select) {
            var opt = Array.prototype.slice.call(select.options).filter(function (o) { return o.value === id && !o.disabled; })[0];
            if (opt) {
              select.value = id;
              self.syncExtraVariant(select);
              hit = true;
            }
          } else if (check.value === id) {
            check.checked = true;
            hit = true;
          }
          // Aantal: wordt in update() nog begrensd op model en voorraad
          if (hit && bits[1] && wrap.querySelector('[data-wvc-qty]')) check.dataset.qty = String(parseInt(bits[1], 10) || 1);
        });
      });
    }
  };

  /* ---------- Delen en naar de winkel sturen ---------- */

  var STORE_KEY = 'wvc-store-sent';

  function storageGet() {
    try {
      var raw = window.sessionStorage.getItem(STORE_KEY);
      var data = raw ? JSON.parse(raw) : null;
      // Alleen een recente verzending (30 min) telt
      return data && Date.now() - (data.t || 0) < 30 * 60 * 1000 ? data : null;
    } catch (e) {
      return null;
    }
  }

  function storageSet(data) {
    try {
      if (data) window.sessionStorage.setItem(STORE_KEY, JSON.stringify(data));
      else window.sessionStorage.removeItem(STORE_KEY);
    } catch (e) { /* privévenster e.d.: dan zonder overzicht */ }
  }

  // Verstuurd via de controlepagina van Shopify: die stuurt je terug naar deze pagina zonder je keuzes.
  // Zet de bewaarde configuratie dan terug in de URL, zodat applyUrl() hem weer opbouwt.
  Configurator.prototype.restoreAfterPost = function () {
    var posted = this.posted && this.posted.getAttribute('data-wvc-store-posted');
    if (!posted && !/[?&]contact_posted=true/.test(window.location.search)) return;
    var saved = storageGet();
    this.returnedFromPost = posted || 'ok';
    this.sentData = posted === 'error' ? null : saved;
    this.sentMode = saved && saved.mode;
    if (saved && saved.search && window.history && window.history.replaceState) {
      window.history.replaceState(window.history.state, '', window.location.pathname + saved.search + window.location.hash.replace(/#wvc-store.*/, ''));
    }
  };

  Configurator.prototype.bindDialog = function () {
    var dialog = this.dialog;
    if (!dialog) return;
    var self = this;

    // Naar <body>, buiten elke stapelcontext van het thema (zie CSS). Een oude kopie (editor) eerst weg.
    Array.prototype.slice.call(document.querySelectorAll('body > [data-wvc-dialog], body > [data-wvc-dialog-backdrop]')).forEach(function (el) {
      if (el !== dialog && el !== self.backdrop && (el.id === dialog.id || el.dataset.for === dialog.id)) el.remove();
    });
    if (this.backdrop) {
      this.backdrop.dataset.for = dialog.id;
      document.body.appendChild(this.backdrop);
      this.backdrop.addEventListener('click', function () { self.closeDialog(); });
    }
    document.body.appendChild(dialog);

    dialog.querySelectorAll('[data-wvc-dialog-close]').forEach(function (b) {
      b.addEventListener('click', function () { self.closeDialog(); });
    });
    dialog.addEventListener('keydown', function (event) { self.dialogKeys(event); });
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      self.closeDialog();
    });

    var copy = dialog.querySelector('[data-wvc-share-copy]');
    if (copy) copy.addEventListener('click', function () { self.copyLink(copy); });

    var native = dialog.querySelector('[data-wvc-share-native]');
    if (native && navigator.share) {
      native.hidden = false;
      native.addEventListener('click', function () {
        navigator.share({ title: self.labels.shareSubject, text: self.shareText(false), url: self.shareUrl() }).catch(function () {});
      });
    }

    var form = dialog.querySelector('[data-wvc-store-form] form');
    if (form) this.bindStoreForm(form);

    // Terug van de controlepagina van Shopify: open de pop-up met het overzicht (of de foutmelding)
    var posted = this.returnedFromPost;
    if (posted) {
      storageSet(null);
      window.setTimeout(function () {
        self.setDialogMode(self.sentMode);
        if (posted !== 'error') self.showSent(self.sentData || {});
        self.openDialog(null);
      }, 300);
    }
  };

  Configurator.prototype.dialogKeys = function (event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeDialog();
      return;
    }
    if (event.key !== 'Tab') return;
    // Focus binnen de pop-up houden
    var items = Array.prototype.slice.call(this.dialog.querySelectorAll('a[href], button, input, textarea, select')).filter(function (el) {
      return !el.disabled && el.tabIndex !== -1 && el.type !== 'hidden' && el.offsetParent !== null;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  Configurator.prototype.shareText = function (withUrl) {
    var self = this;
    var extras = this.selectedExtras().map(function (c) { return self.extraName(c); });
    var lines = [this.labels.shareText, this.rows.length ? this.rows[0][0] : ''];
    this.choiceChanges().forEach(function (ch) { lines.push(ch[0] + ': ' + ch[1]); });
    if (extras.length) lines.push('+ ' + extras.join(', '));
    lines.push(this.labels.total + ': ' + formatMoney(this.total, this.data.money));
    var text = lines.filter(Boolean).join('\n');
    return withUrl ? text + '\n\n' + this.shareUrl() : text;
  };

  Configurator.prototype.currentImage = function () {
    var imgs = this.images();
    var current = imgs[this.imageIndex] || imgs[0];
    return current ? current.m : '';
  };

  // Dezelfde pop-up, meerdere doelen: delen/naar de winkel sturen, of een proefrit, levertijd of hulp bij de maat vragen
  Configurator.prototype.setDialogMode = function (mode) {
    var dialog = this.dialog;
    if (!dialog) return;
    var kinds = { share: 'Configuratie', testride: 'Proefrit', delivery: 'Levertijd', size: 'Vraag over maat' };
    if (!kinds[mode]) mode = 'share';
    this.dialogMode = mode;
    dialog.classList.toggle('wvc-dialog--testride', mode !== 'share');
    dialog.querySelectorAll('[data-wvc-mode-text]').forEach(function (el) {
      if (el.dataset[mode]) el.textContent = el.dataset[mode];
    });
    var body = dialog.querySelector('[data-wvc-mode-placeholder]');
    if (body && body.dataset[mode]) body.placeholder = body.dataset[mode];
    var kind = dialog.querySelector('[data-wvc-store-kind]');
    if (kind) kind.value = kinds[mode];
  };

  Configurator.prototype.openDialog = function (opener, mode) {
    var dialog = this.dialog;
    if (!dialog) return;
    this.dialogOpener = opener;
    if (mode) this.setDialogMode(mode);
    var url = this.shareUrl();

    // Inhoud bijwerken met de huidige configuratie
    var img = dialog.querySelector('[data-wvc-share-img]');
    var src = this.currentImage();
    if (img && src) {
      img.src = src;
      img.hidden = false;
    }
    var name = dialog.querySelector('[data-wvc-share-name]');
    if (name) name.textContent = this.rows.length ? this.rows[0][0] : '';
    var extra = dialog.querySelector('[data-wvc-share-extra]');
    if (extra) {
      var self = this;
      var names = this.selectedExtras().map(function (c) { return self.extraName(c); });
      extra.textContent = names.length ? '+ ' + names.join(', ') : '';
      extra.hidden = names.length === 0;
    }
    var total = dialog.querySelector('[data-wvc-dialog-total]');
    if (total) total.textContent = formatMoney(this.total, this.data.money);

    var wa = dialog.querySelector('[data-wvc-share-whatsapp]');
    if (wa) wa.href = 'https://wa.me/?text=' + encodeURIComponent(this.shareText(true));
    var mail = dialog.querySelector('[data-wvc-share-mail]');
    if (mail) mail.href = 'mailto:?subject=' + encodeURIComponent(this.labels.shareSubject || '') + '&body=' + encodeURIComponent(this.shareText(true));
    var link = dialog.querySelector('[data-wvc-share-link]');
    if (link) link.value = url;

    document.documentElement.classList.add('wvc-dialog-open');
    if (this.backdrop) this.backdrop.hidden = false;
    if (!dialog.open) {
      if (typeof dialog.show === 'function') dialog.show();
      else dialog.setAttribute('open', '');
    }
    var focusEl = dialog.querySelector('[data-wvc-store-done]:not([hidden]) [data-wvc-sent-title]') || dialog.querySelector('[data-wvc-dialog-close]');
    if (focusEl) focusEl.focus({ preventScroll: true });
    dialog.scrollTop = 0;
  };

  Configurator.prototype.closeDialog = function () {
    var dialog = this.dialog;
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    if (this.backdrop) this.backdrop.hidden = true;
    document.documentElement.classList.remove('wvc-dialog-open');

    // Na een verzending: volgende keer weer het gewone deelscherm
    var main = dialog.querySelector('[data-wvc-dialog-main]');
    var done = dialog.querySelector('[data-wvc-store-done]');
    if (done && !done.hidden) {
      done.hidden = true;
      if (main) main.hidden = false;
    }
    this.setDialogMode('share');
    if (this.dialogOpener && document.contains(this.dialogOpener)) this.dialogOpener.focus({ preventScroll: true });
  };

  // Bedankscherm met overzicht van wat er naar de winkel ging
  Configurator.prototype.showSent = function (data) {
    var dialog = this.dialog;
    var main = dialog.querySelector('[data-wvc-dialog-main]');
    var done = dialog.querySelector('[data-wvc-store-done]');
    var rows = data.rows || [];
    var recap = dialog.querySelector('.wvc-recap');
    // Zonder bewaarde gegevens (bijv. privévenster na de controlepagina) alleen het bedankje tonen
    if (recap) recap.hidden = rows.length === 0;
    var lines = dialog.querySelector('[data-wvc-recap-lines]');
    if (lines) {
      while (lines.firstChild) lines.removeChild(lines.firstChild);
      rows.forEach(function (r) {
        var li = document.createElement('li');
        if (r[2] === 'wvc-summary__line--fit') li.className = 'is-fit';
        var a = document.createElement('span');
        a.textContent = r[0];
        var b = document.createElement('span');
        b.textContent = r[1];
        li.appendChild(a);
        li.appendChild(b);
        lines.appendChild(li);
      });
    }
    var total = dialog.querySelector('[data-wvc-recap-total]');
    if (total) total.textContent = data.total || '';
    var img = dialog.querySelector('[data-wvc-recap-img]');
    var src = data.img || '';
    if (img) {
      img.hidden = !src;
      if (src) img.src = src;
    }
    var mailWrap = dialog.querySelector('[data-wvc-sent-mail]');
    var mail = dialog.querySelector('[data-wvc-sent-email]');
    if (mailWrap && mail) {
      mail.textContent = data.email || '';
      mailWrap.hidden = !data.email;
    }
    if (main) main.hidden = true;
    if (done) done.hidden = false;
    dialog.scrollTop = 0;
    var title = dialog.querySelector('[data-wvc-sent-title]');
    if (title && dialog.open) title.focus({ preventScroll: true });
  };

  Configurator.prototype.copyLink = function (btn) {
    var url = this.shareUrl();
    var label = btn.querySelector('[data-wvc-copy-label]') || btn;
    var original = label.dataset.original || label.textContent;
    label.dataset.original = original;
    var labels = this.labels;
    var done = function () {
      label.textContent = labels.copied;
      btn.classList.add('is-done');
      window.setTimeout(function () {
        label.textContent = original;
        btn.classList.remove('is-done');
      }, 2200);
    };
    var field = this.dialog && this.dialog.querySelector('[data-wvc-share-link]');
    var fallback = function () {
      if (field) {
        field.hidden = false;
        field.focus();
        field.select();
      } else {
        window.prompt('', url);
      }
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, fallback);
    } else {
      fallback();
    }
  };

  // Formulier "Stuur naar de winkel": het gewone Shopify-contactformulier, met de configuratie erbij.
  Configurator.prototype.fillStoreForm = function (form) {
    var config = form.querySelector('[data-wvc-store-config]');
    if (config) config.value = this.rows.map(function (r) { return r[0] + ' – ' + r[1]; }).join('\n');
    var total = form.querySelector('[data-wvc-store-total]');
    if (total) total.value = formatMoney(this.total, this.data.money);
    var link = form.querySelector('[data-wvc-store-link]');
    if (link) link.value = this.shareUrl();
  };

  Configurator.prototype.sentSnapshot = function (form) {
    var email = form.querySelector('[name="contact[email]"]');
    var url = this.shareUrl();
    return {
      t: Date.now(),
      search: url.slice(url.indexOf('?')),
      mode: this.dialogMode || 'share',
      rows: this.rows,
      total: formatMoney(this.total, this.data.money),
      img: this.currentImage(),
      email: email ? email.value : ''
    };
  };

  Configurator.prototype.bindStoreForm = function (form) {
    var self = this;
    var error = this.dialog.querySelector('[data-wvc-store-error]');
    var submit = form.querySelector('[data-wvc-store-submit]');
    var submitLabel = submit ? submit.textContent : '';
    var busy = false;
    var nativeNext = false;

    var finish = function () {
      busy = false;
      if (submit) {
        submit.disabled = false;
        submit.textContent = submit.dataset[self.dialogMode || 'share'] || submitLabel;
      }
    };
    var fail = function () {
      if (error) {
        error.textContent = self.labels.storeError;
        error.hidden = false;
      }
      finish();
    };
    // Gewoon versturen (pagina laadt opnieuw, eventueel via de controlepagina van Shopify).
    // De configuratie gaat mee in sessionStorage, zodat we hem na terugkomst weer tonen.
    var sendNative = function () {
      storageSet(self.sentSnapshot(form));
      form.submit();
    };

    var send = function () {
      var snapshot = self.sentSnapshot(form);
      var action = form.getAttribute('action').split('#')[0];
      var ctrl = 'AbortController' in window ? new AbortController() : null;
      var timer = ctrl ? window.setTimeout(function () { ctrl.abort(); }, 20000) : null;
      fetch(action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (res) {
          if (timer) window.clearTimeout(timer);
          if (/[?&]contact_posted=true/.test(res.url)) {
            form.reset();
            finish();
            self.showSent(snapshot);
            return;
          }
          if (/\/challenge/.test(res.url)) {
            sendNative();
            return;
          }
          fail();
        })
        .catch(fail);
    };

    // Vang het verzenden af vóórdat het captchascript van Shopify (luistert op het formulier zelf) het oppakt,
    // zodat er precies één verzending is. Shopify.captcha.protect regelt de controle (eventueel met een puzzel,
    // die nu boven de pop-up verschijnt) en roept daarna send() aan.
    this.dialog.addEventListener('submit', function (event) {
      if (event.target !== form) return;
      event.preventDefault();
      event.stopPropagation();
      if (busy) return;
      self.fillStoreForm(form);
      if (nativeNext || !window.fetch || !window.FormData) {
        sendNative();
        return;
      }
      busy = true;
      if (error) error.hidden = true;
      if (submit) {
        submit.disabled = true;
        submit.textContent = self.labels.sending;
      }
      var captcha = window.Shopify && window.Shopify.captcha;
      if (captcha && typeof captcha.protect === 'function') {
        var called = false;
        var go = function () {
          if (called) return;
          called = true;
          send();
        };
        try {
          captcha.protect(form, function () {
            // protect() meldt alleen dat het formulier gekoppeld is: de token vragen we hier zelf op
            var frame = form.querySelector('.h-captcha iframe[data-hcaptcha-widget-id]');
            if (!window.hcaptcha || !frame) {
              called = true;
              sendNative();
              return;
            }
            var widget = frame.getAttribute('data-hcaptcha-widget-id');
            window.hcaptcha.reset(widget);
            window.hcaptcha.execute(widget, { async: true }).then(function (result) {
              var field = form.elements['h-captcha-response'];
              if (field) field.value = result.response;
              go();
            }).catch(function () {
              if (called) return;
              called = true;
              nativeNext = true;
              fail();
            });
          });
        } catch (e) {
          go();
        }
        // Geen antwoord van de captcha (geblokkeerd of puzzel gesloten): niets versturen, knop vrijgeven.
        // Een volgende klik verstuurt via de controlepagina van Shopify.
        window.setTimeout(function () {
          if (called) return;
          called = true;
          nativeNext = true;
          fail();
        }, 30000);
      } else {
        send();
      }
    }, true);
  };

  /* ---------- Mobiele balk ---------- */

  Configurator.prototype.observeBar = function () {
    var bar = this.bar;
    var stage = this.q('[data-wvc-stage]');
    var summary = this.q('.wvc-summary');
    if (!bar || !stage || !('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(max-width: 989px)');
    var state = { stage: true, summary: false };

    var apply = function () {
      var on = mq.matches && !state.stage && !state.summary;
      bar.classList.toggle('is-visible', on);
      document.body.classList.toggle('wvc-bar-on', on);
      if (on) document.body.style.setProperty('--wvc-bar-h', bar.offsetHeight + 'px');
    };

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.target === stage) state.stage = e.isIntersecting || e.boundingClientRect.top > 0;
        if (e.target === summary) state.summary = e.isIntersecting;
      });
      apply();
    }, { threshold: 0 });
    io.observe(stage);
    if (summary) io.observe(summary);
    if (mq.addEventListener) mq.addEventListener('change', apply);
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-wvc]').forEach(function (root) {
      if (root.__wvc) return;
      root.__wvc = new Configurator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: sectie opnieuw geladen
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-wvc]');
    var c = root && root.__wvc;
    if (c && c.dialog) {
      document.documentElement.classList.remove('wvc-dialog-open');
      c.dialog.remove();
      if (c.backdrop) c.backdrop.remove();
    }
  });
})();
